<template>
<v-dialog 
    v-model="show_dialog" 
    max-width="800"
>

    <v-card>
    <v-card-title class="headline">
        Trying to connect...
    </v-card-title>

    <v-card-text>
        <p>We are having trouble connecting to the internet.</p>

        <p>Please check your internet connection and try again.</p>
        
        <code 
            v-if="show_technical_details"
            style="display: block; white-space: pre;"
        >
            {{response_json_pretty_print}}
        </code>
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="signOut"
        >
            Sign Out
        </v-btn>

         <v-btn
            color="gray darken-1"
            text
            @click="showTechnicalDetails"
            v-if="!show_technical_details"
        >
            Show technical details
        </v-btn>

        <v-btn
            color="gray darken-1"
            text
            @click="onReloadPage"
        >
            Try Again
        </v-btn>
    </v-card-actions>
    </v-card>

</v-dialog>
    
</template>

<script>

export default {
    data() {
        return {
            show_dialog: false,
            response: null,
            show_technical_details: false,
            response_json_pretty_print: null,
            try_servers_interval: null,
        }
    },

    created () {
    },

    beforeDestroy () {
    },

    methods: 
    {
        showDialog(response) {
            this.response = response;
            this.response_json_pretty_print = JSON.stringify(response,null,2);

            this.show_technical_details = false;

            this.show_dialog = true;

            this.try_servers_interval = window.setInterval(this.tryServers, 1000);
        },

        tryServers()
        {
            // Turn off the backstop error handler so the dialog is not opened over and over again...
            this.$event_bus.$off('backstop-error-handler');

            this.$rc.makeTestAPICall(
                200, 
                'Test Servers Up', 
                (response) =>{
                    if ( response != null && response.http_status_code === 200 )
                    {
                        // window.clearInterval(this.try_servers_interval);
                        location.reload();
                    }
                }
            );
        },

        showTechnicalDetails()
        {
            this.show_technical_details = true;
        },

        onReloadPage()
        {
            location.reload();
        },

        signOut()
        {
            this.$rc.signOut();

            this.$router.push({
                'name': 'sign-in',
            }).catch(e=>{}); // swallow any exception
        },
    },
}
</script>

<style scoped>

</style>